import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule } from '@spartacus/core';
import { KbOpenPositionTableComponent } from './kb-open-position-table.component';
import { KbPaginationModule } from 'src/app/customcomponents/kb-pagination/kb-pagination/kb-pagination.module';

@NgModule({
  imports: [CommonModule, I18nModule, KbPaginationModule, RouterModule],
  declarations: [KbOpenPositionTableComponent],
  exports: [KbOpenPositionTableComponent],
})
export class KbOpenPositionTableModule {}
